export default __webpack_public_path__ + "static/white-paper-desktop-b6435ca7d828653f25f8086a7c37278d.png";